
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  name: "Cookie",
  computed: mapGetters("app", ["getCookie"])
})
export default class Cookie extends Vue {
  isShowCookie: boolean = true;

  mounted() {
    const storageCookie = localStorage.getItem("hide-cookie");
    this.isShowCookie = !storageCookie;
    this.$store.dispatch("app/toggleCookie", this.isShowCookie);
  }
  handleClose() {
    localStorage.setItem("hide-cookie", "true");
    this.isShowCookie = false;
    this.$store.dispatch("app/toggleCookie", this.isShowCookie);
  }
}
